import { all, call, put, takeLatest } from 'redux-saga/effects';
import api from '../../services/api';
import types from '../types';
import notification from '../../services/notification';
import { modal } from '../../components/Base/Modal';

function* getTradeVolumeSettings() {
  try {
    const { data, status } = yield call(
      api.tradeVolumeSettings.getTradeVolumeSettings,
    );
    if (status < 200 && status >= 300) throw new Error('Something went wrong');
    yield put({ type: types.GET_TRADE_VOLUME_SETTINGS_SUCCESS, payload: data });
  } catch (error) {
    yield put({ type: types.GET_TRADE_VOLUME_SETTINGS_FAILURE });
    if (error?.response?.status === 401) return;
    notification({
      message: error?.response?.data?.errors?.length
        ? error?.response?.data?.errors[0].replace(/_/g, ' ')
        : 'Something went wrong',
    });
  }
}

function* editTradeVolumeSettings({ payload }) {
  try {
    const { status } = yield call(
      api.tradeVolumeSettings.editTradeVolumeSettings,
      payload,
    );
    if (status < 200 && status >= 300) throw new Error('Something went wrong');
    yield put({ type: types.PUT_TRADE_VOLUME_SETTINGS_SUCCESS });
    yield put({ type: types.GET_TRADE_VOLUME_SETTINGS_START });
    notification({ type: 'success', message: 'Success' });
  } catch (error) {
    yield put({ type: types.PUT_TRADE_VOLUME_SETTINGS_FAILURE });
    if (error?.response?.status === 401) return;
    notification({
      message: error?.response?.data?.errors?.length
        ? error?.response?.data?.errors[0].replace(/_/g, ' ')
        : 'Something went wrong',
    });
  }
}

export function* tradeVolumeSettings() {
  yield all([
    takeLatest(types.GET_TRADE_VOLUME_SETTINGS_START, getTradeVolumeSettings),
    takeLatest(types.PUT_TRADE_VOLUME_SETTINGS_START, editTradeVolumeSettings),
  ]);
}
